export default __webpack_public_path__ + "static/media/hotei15.afa94100.webp";